export default __webpack_public_path__ + "static/media/Sev2.3c4066b1.png";